export default __webpack_public_path__ + "static/media/MainImage.2d60df3f.png";